module.exports = __webpack_public_path__ + "img/main-static.01aedcf4.png";